export const METRICS = {
  // Recommendations and Auction Insight
  ImpressionShare: 'ImpressionShare',
  OverlapRate: 'OverlapRate',
  AveragePosition: 'AveragePosition',
  AboveRate: 'AboveRate',
  TopOfPageRate: 'TopOfPageRate',
  AbsoluteTopOfPageRate: 'AbsoluteTopOfPageRate',
  OutrankingShare: 'OutrankingShare',
  // Recommendations
  ConversionRate: 'ConversionRate',
  SearchTerms: 'SearchTerms',
};

export const CHART_TYPES = {
  None: null,
  RecommendationCard: 'RecommendationCard',
  SmallTile: 'SmallTile',
  LargeTile: 'LargeTile',
  Primary: 'Primary',
  Secondary: 'Secondary',
};

export const DEVICE_TYPE = {
  None: null,
  PC: 'PC',
  SmartPhone: 'SmartPhone',
  Tablet: 'Tablet',
};
